import { render, staticRenderFns } from "./SubscriptionsHistory.vue?vue&type=template&id=83a823d2&scoped=true"
import script from "./SubscriptionsHistory.vue?vue&type=script&lang=js"
export * from "./SubscriptionsHistory.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionsHistory.vue?vue&type=style&index=0&id=83a823d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a823d2",
  null
  
)

export default component.exports